<template>
    <div class="call_center_table">
        <!-- 表格 -->
        <el-table
            :data="call_list"
            height="500"
            tooltip-effect="dark">
            <!-- 申请单号 -->
            <el-table-column
                :label="$t('message.ccall.table1')"
                prop="number"
                align="center"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 申请人 -->
            <el-table-column
                :label="$t('message.ccall.table2')"
                prop="member"
                align="center"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 申请金额 -->
            <el-table-column
                :label="$t('message.ccall.table3')"
                prop="amount"
                align="center"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 申请时间 -->
            <el-table-column
                :label="$t('message.ccall.table4')"
                :formatter="createtime"
                align="center"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 申请备注 -->
            <el-table-column
                :label="$t('message.ccall.table5')"
                prop="member_remark"
                align="center"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 审批金额 -->
            <el-table-column
                :label="$t('message.ccall.table6')"
                prop="true_amount"
                align="center"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 审批时间 -->
            <el-table-column
                :label="$t('message.ccall.table7')"
                :formatter="updatetime"
                align="center"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 操作 -->
            <el-table-column
                :label="$t('message.ccall.table8')"
                align="center"
                width="150"
                v-if="character_id == 6">
                <template v-slot="{ row }">
                    <div v-if="row.type == '0'">
                        <el-button
                            type="text"
                            class="center_call_table_btn1"
                            size="mini"
                            @click="handleAgree(row.id, 1, row.amount)">
                            <span>{{$t("message.ccall.agree1")}}</span>
                        </el-button>
                        <el-button
                            type="text"
                            class="center_call_table_btn2"
                            size="mini"
                            @click="handleAgree(row.id, 2)">
                            <span>{{$t("message.ccall.agree2")}}</span>
                        </el-button>
                    </div>
                    <div class="center_call_table_status" v-else>{{row.type=="1"?$t("message.ccall.agree4"):$t("message.ccall.agree5")}}</div>
                </template>
            </el-table-column>
            <!-- 状态 -->
            <el-table-column
                :label="$t('message.ccall.table9')"
                align="center"
                v-else>
                <template v-slot="{ row }">
                    <div>{{computeStatus(row.type)}}</div>
                </template>
            </el-table-column>
        </el-table>
        <!-- 下载 -->
        <div class="call_center_download">
            <el-button
                type="primary"
                @click="handleDownload">
                <span>下载</span>
            </el-button>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
    data() {
        return {
            order: [],
        }
    },
    computed: mapState({
        call_list: state => state.call.call_list,
        character_id: state => state.user.character_id
    }),
    methods: {
        ...mapActions([
            "handleCallApproval",
            "getCallcenterList"
        ]),
        createtime(row, column){
            return row.createtime.split(' ')[0]
        },
        updatetime(row, column){
            if(row.updatetime) return row.updatetime.split(' ')[0]
        },
        computeStatus(val){
            switch (val) {
                case '0':
                    return this.$t("message.ccall.agree3");
                    break;
                case '1':
                    return this.$t("message.ccall.agree1");
                    break;
                case '2':
                    return this.$t("message.ccall.agree2");
                    break;
            }
        },
        handleDownload(){ // 下载表格按钮
            let url = this.$URL.baseUrl + "index/resource/excel";
            window.open(url);
        },
        handleAgree(id, type, amount){
            let true_amount = "",
            member_remark = "";
            if(type == 1){ // 同意
                this.$prompt(this.$t("message.ccall.prompt1"), {
                    confirmButtonText: this.$t("public.confirmBtn"),
                    cancelButtonText: this.$t("public.cancelBtn"),
                    inputPattern: /^[1-9]\d*$/,
                    inputPlaceholder: amount,
                    inputErrorMessage: this.$t("message.ccall.prompt1")
                }).then(({ value }) => {
                    true_amount = value;
                    this.$prompt(this.$t("message.ccall.prompt2"), {
                        confirmButtonText: this.$t("public.confirmBtn"),
                        cancelButtonText: this.$t("public.cancelBtn"),
                    }).then(({ value }) => {
                        member_remark = value;
                        this.handleCallApproval({
                            id,
                            type,
                            true_amount,
                            member_remark
                        }).then((res) => {
                            if(res.type){
                                this.$message({
                                    showClose: true,
                                    message: this.$t("message.ccall.succmsg1"),
                                    type: "success"
                                })
                                this.getCallcenterList();
                            }else{
                                this.$message({
                                    showClose: true,
                                    message: this.$t("message.ccall.errmsg1"),
                                    type: "error"
                                })
                            }
                        })
                    }).catch(() => {})
                }).catch(() => {})
            }else{ // 不同意
                this.$prompt(this.$t("message.ccall.prompt2"), {
                    confirmButtonText: this.$t("public.confirmBtn"),
                    cancelButtonText: this.$t("public.cancelBtn"),
                }).then(({ value }) => {
                    member_remark = value;
                    this.handleCallApproval({
                        id,
                        type,
                        true_amount,
                        member_remark
                    }).then((res) => {
                        if(res.type){
                            this.$message({
                                showClose: true,
                                message: this.$t("message.ccall.succmsg1"),
                                type: "success"
                            })
                            this.getCallcenterList();
                        }
                    })
                }).catch(() => {})
            }
        },
    },
}
</script>

<style scoped>
.call_center_table{
    background-color: #fff;
}
.center_call_table_btn1{
    color: #409EFF
}
.center_call_table_btn2{
    color: #F56C6C
}
.center_call_table_status{
    color: #909399
}
/* 下载 */
.call_center_download{
    text-align: right;
}
</style>
